var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImport(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.05 16C2.813 16 1 14.128 1 11.821 1 10 2.13 8.45 3.706 7.878a5.034 5.034 0 01-.006-.235C3.7 5.078 5.714 3 8.2 3c1.668 0 3.122.936 3.901 2.327.427-.322.945-.47 1.499-.47 1.49 0 2.7 1.222 2.7 2.786 0 .354-.065.69-.18 1.004 1.642.342 2.88 1.842 2.88 3.639C19 14.337 17.388 16 15.4 16H5.05zm2.222-6.297c-.262.273-.262.714 0 .96.264.297.692.297.93 0l1.123-1.108v3.891c0 .386.301.697.675.697.374 0 .675-.31.675-.697v-3.89l1.097 1.108c.264.296.692.296.93 0 .288-.247.288-.688 0-.96l-2.249-2.322c-.24-.27-.667-.27-.931 0l-2.25 2.321z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default ForwardRef;